export const DEFAULT_QUEUE_SHARD_COUNT = 64;
